<h1 mat-dialog-title class="notification-title">{{ 'topbar.logout.dialogheader' | translate }}</h1>
<div mat-dialog-actions class="acies-dialog-button-bar">
	<button mat-flat-button color="primary" [mat-dialog-close]="true">{{ 'topbar.logout.yes' | translate }}</button>
	<button mat-flat-button color="primary" cdkFocusInitial [mat-dialog-close]="false">{{ 'topbar.logout.no' | translate }}</button>
</div>
